import SystemMeter from '@components/_shared/SystemMeter';
import MegapackList from '@components/Battery/Tesla/MegapackList';
import TeslaControllerDetails from '@components/Battery/Tesla/TeslaControllerDetails';
import { CurrentTscDeviceProvider } from '@hooks/useCurrentTscDevice';
import TeslaControllerList from '@components/Battery/Tesla/TeslaControllerList';
import { ReactElement } from 'react';

function TESLA(): ReactElement {
  return (
    <CurrentTscDeviceProvider>
      <div className='home-row'>
        <div className='fcol'>
          <SystemMeter />
          <TeslaControllerList />
        </div>
        <div className='fcol'>
          <TeslaControllerDetails />
          <MegapackList />
        </div>
      </div>
    </CurrentTscDeviceProvider>
  );
}

export default TESLA;
